// Save repository — an interface plus a localStorage adapter. State only
// talks to repository, not localStorage directly. To add a backend later,
// implement the same shape (HttpRepository.load/save) and swap which one
// state.js imports — nothing else needs to change.
//
// Interface:
//   load() → state object
//   save(state) → void
//   clear() → void

import { SaveKey } from '../config/balance.js'

export const LocalStorageRepository = {
  load() {
    try {
      const raw = localStorage.getItem(SaveKey)
      return raw ? JSON.parse(raw) : null
    } catch (err) {
      console.warn('[repository.local] parse failed:', err)
      return null
    }
  },
  save(state) {
    try {
      localStorage.setItem(SaveKey, JSON.stringify(state))
    } catch (err) {
      console.warn('[repository.local] write failed:', err)
    }
  },
  clear() {
    localStorage.removeItem(SaveKey)
  },
}

// PHASE 3+: HTTP-backed repository. Mirrors writes to a server and falls
// back to localStorage when offline. Swap into state.js when the backend lands.
//
// export const HttpRepository = {
//   async load() { ... },
//   async save(state) { ... },
//   async clear() { ... },
// }

// Active repository. To swap implementations later, change this default.
export const Repository = LocalStorageRepository
